/*
 * @module:
 * @Author: 张前领<qianling.zhang@hand-china.com>
 * @Date: 2021-06-16 14:03:14
 * @LastEditTime: 2022-08-03 16:52:21
 * @copyright: Copyright (c) 2020,Hand
 */

import React from "react";
import {useFBX} from "@react-three/drei";
export function getUrlParam(k) {
  const reg = new RegExp(`(^|&)${k}=([^&]*)(&|$)`)
  const r = decodeURIComponent(window.location.search.substr(1)).match(reg)
  if (r != null) return unescape(r[2])
  return null
}
export default function Model(props) {
  const fbx = useFBX(decodeURIComponent(getUrlParam('modelSrc'))??props.url);
  return (
    <primitive object={fbx} dispose={null}  scale={10} />
  );
}
